import TableCell from "@material-ui/core/TableCell";
// material-ui
import { withStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import React, { Component } from "react";
// styles
import styles from "./styles";

class RendTableCell extends Component {
  static propTypes = {
    classes: PropTypes.object,
    children: PropTypes.any,
    align: PropTypes.string,
  };

  render() {
    const { children, align } = this.props;

    return <TableCell align={align || undefined}>{children}</TableCell>;
  }
}

export default withStyles(styles)(RendTableCell);
